module.exports = __webpack_public_path__ + "img/art2-img2.0c4412c3.jpeg";